<template>
  <v-container hidden />
</template>
<script>
export default {
  name: 'years',
  mounted () {
    this.$router.push({
      path: `/years/${this.$root.years[0]}`
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/years.vue